<template>
  <tm-skeleton-table
    :rows="rows"
    :columns="columns"
    :hide-gradient="hideGradient"
  >
    <template v-slot:table-header>
      <tm-table-header
        :service-id="serviceId"
        :has-actions="hasActions"
        :visible-columns="headerColumns"
        :hide-checkbox="hideCheckboxes"
        :has-other-sticky-cells="false"
        disabled
      />
    </template>
  </tm-skeleton-table>
</template>

<script setup lang="ts">
import type { ColumnLoader, DefaultColumn } from '@/core/tables/types'
import { getDefaultLoaderColumnsConfig } from '@/composition/table/getDefaultLoaderColumnsConfig'
import TmTableHeader from '@/components/shared/tables/TmTableHeader.vue'
import type { RegisteredServices } from '@/core/container/types'
import TmSkeletonTable from '@/components/shared/skeletons/TmSkeletonTable.vue'

withDefaults(
  defineProps<{
    serviceId: RegisteredServices
    rows?: number
    columns?: ColumnLoader[]
    headerColumns?: DefaultColumn[]
    hideGradient?: boolean
    hideCheckboxes?: boolean
    hasActions?: boolean
  }>(),
  {
    rows: 10,
    columns: getDefaultLoaderColumnsConfig,
    headerColumns: (): DefaultColumn[] => [],
    hideGradient: false,
    hideCheckboxes: false,
    hasActions: false,
  },
)
</script>
